import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { LoadingModule } from '@components/loading';
import { BroadcastService } from '@services/broadcast-service';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import { RegimenConcernSelectionModule } from '@shared/regimen-concern-selection/regimen-concern-selection.module';
import { AppConfig } from 'client/app/app.config';

@Component({
  selector: 'app-re-acquisition-concern-selection',
  imports: [
    CommonModule,
    CsIconModule,
    LoadingModule,
    ButtonModule,
    RegimenConcernSelectionModule,
  ],
  templateUrl: './re-acquisition-concern-selection.component.html',
})
export class ReAcquisitionConcernSelectionComponent {
  isRebranding: boolean = false;
  selectedConcernClass: string = '';
  user: Table.User;
  isSpentLessThanThreshold: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly appConfig: AppConfig,
    private readonly broadcast: BroadcastService,
    private readonly eventLogger: EventLoggerService,
    private readonly connectionService: ConnectionService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.user = this.connectionService.getActingUser();
    this.isSpentLessThanThreshold = this.route.snapshot.queryParams?.isSpentLessThanThreshold;
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_concern_selection' }));
  }

  async updateConcern(selectedConcernClass: string): Promise<void> {
    if (selectedConcernClass === this.appConfig.Shared.Regimen.Class.FACE) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'reacquisition_face_selected' }));
    } else if (selectedConcernClass === this.appConfig.Shared.Regimen.Class.HAIR) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'reacquisition_hair_selected' }));
    }
    if (!this.isSpentLessThanThreshold) {
      this.router.navigate(['/re-acquisition/take-photo'], { queryParams: { selectedConcern: selectedConcernClass.toLowerCase(), isRebranding: true } });
      return;
    }
    const session = await this.connectionService.findConsultationSession(selectedConcernClass);
    if (session?.get('PrivateMainConcern')) {
      try {
        const concerns = (session?.get('concernList') || []).length ? session?.get('concernList') : [session?.get('PrivateMainConcern')];
        await this.connectionService.saveUserMainConcern(concerns);
        await this.router.navigate(['/user'],
          { queryParams: { tab: 'chat', username: this.user?.get('username') } });
      } catch (err) {
        this.eventLogger.logError(err, false, 'reacquisition_concern_selection_error')
        this.broadcast.broadcast('NOTIFY', { message: err.toString() });
      }
    } else {
      await this.router.navigate(['/mainConcern'], { queryParams: { class: selectedConcernClass, redirectOnBack: '/home' } });
    }
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }
}
